import router from './router';
import store from './store';
import {getToken, removeToken} from './utilis/auth';
import middlewares from './middlewares/index';
import {check_permissions} from './middlewares/user_permisssions'
import {storeIntegrationInCookies} from "./utilis/integration_cookies";

/*router.beforeEach(async (to, from, next) => {
    if(!store.getters.app.langs){
        store.dispatch('app/getLangs');
    }
    console.log(store.getters.notifications);
    if(store.getters.notifications == null){
        store.dispatch('notifications/getNotifications');
    }
    store.dispatch('user/checkLocation');
    next();
})*/


const goFurther = (next, from, to) => {
    // determine whether the user has logged in
    const hasToken = getToken();
    if(to.query.api_key && to.query.domain){
        storeIntegrationInCookies({
            token: to.query.api_key,
            shop: to.query.domain,
            api_key: to.query.api_key,
            domain : to.query.domain
        }, 'shopify');
    }
    if(store.getters.activeWebsite && store.getters.activeWebsite.amount_of_products == 0){
        store.dispatch('websites/setActive', store.getters.activeWebsite);
    }
    var next_step = () => {
        if (to.meta.guest == true) {
            next({ path: '/' });
        } else {
            if(!store.getters.user.id){
                store.dispatch('app/getProgress');
                store.dispatch('user/getUser').then(response => {
                    if(check_permissions(from, to, next)){
                        next();
                    } else {
                        store.commit('app/ADD_MESSAGE', {text: 'You don\'t have permission to access this resource.', type:'error'});
                        //next({path:from.path, replace: true});
                    }
                    /* if(!store.getters.user.email_verified_at){
                         if(to.path !== '/verify'){
                             next('/verify');
                         }
                     }
                     if(to.path == '/verify') next('/');*/

                   // next();
                });
            }else{
                if(check_permissions(from, to, next)){
                    next();
                } else {
                    store.commit('app/ADD_MESSAGE', {text: 'You don\'t have permission to access this resource.', type:'error'});
                   // next({path:from.path, replace: true});
                }
            }
        }
    }
    if (hasToken) {
        if(store.getters.websites == null){
            store.dispatch('websites/getWebsites').then(res => {
                next_step();
            }).catch(e => {
                next_step();
            });
        }else{
            next_step();
        }
    } else {
        if (to.meta.auth == true) {
            // in the free login whitelist, go directly
            next({path: '/login', query: to.query});
        } else {
            next();
        }
    }
}
router.beforeEach(async(to, from, next) => {
    // start progress bar
    // set page title
    store.commit('app/SET_BOTTOM', null);
    if(to.meta.title){
        document.title =to.meta.title;
    }
    store.commit('app/setLoading', true);
    if(!store.getters.app_info_initialized){
        store.dispatch('app/getInfo').then(res => {
            goFurther(next, from, to);
        });
    }else{
        goFurther(next, from, to);
    }
});

router.beforeEach((to, from ,next) => {
    if(to.meta.middlewares){
        var jarPromise = [];
        to.meta.middlewares.forEach(middleware => {
            jarPromise.push(middlewares[middleware](to, from ,next));
        })
        Promise.all(jarPromise.map(p => p.catch(e => e))).then(res => {
            var check = true;
            res.forEach(res_item => {
                if(res_item != true){
                    check = false;
                    store.commit('app/ADD_MESSAGE', {text: res_item.message, type:'error'});
                    next(res_item.redirect);
                }
            })
            if(check){
                next();
            }
        })
    }else{
        next();
    }
})

router.afterEach((to) => {
    setTimeout(() => {
        store.commit('app/setLoading', false);
    }, 500)
    if(to.meta.header_visible){
        store.commit('navigation/SET_HEADER', {title: ''});
    }else store.commit('navigation/RESET_HEADER');

})
